<!-- 寄售帮卖 -->
<template>
	<div class="con">
		<!-- 云当铺回收 -->
		<div class="leaveUnused">
			<div class="textCenter f36 pt80">云当铺买卖 </div>
			<div class="textGary">上门检测，卖家自由定价，专业团队帮卖，收益最大化</div>
			<img style="width: 90%;" src="../../static/slider/jsbm.png" />
		</div>
		<div class="button" type="text" @click="showPopup">立即买卖</div>

		<Popup :visible="popupVisible" :content="popupContent" @close="closePopup" />


	</div>
</template>
<script>
	import Popup from "../components/popup.vue";
	export default {
		components: {
			Popup
		},
		data() {
			return {
				popupVisible: false,
				popupContent: '这是一个弹窗'
			};
		},

		methods: {
			showPopup() {
				this.popupVisible = true;
			},
			closePopup() {
				this.popupVisible = false;
			}
		},
		computed: {
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require("../../static/other/arrow.png");
				} else {
					return require("../../static/other/arrow_down.png");
				}
			}
		}
	}
</script>
<style lang="less" scoped>
	/* 云当铺回收 */
	.con {
		padding-bottom: 4rem;
	}

	.leaveUnused {
		width: 90%;
		margin: auto;

		.textGary {
			font-size: 24rpx;
			text-align: center;
			color: #999;
			margin-top: 0.5rem;
		}

		img {
			margin-left: 5%;
			margin-top: 4rem;
			margin-bottom: 4rem;
		}

	}

	.button {
		border: solid 1px #999;
		color: #999;
		text-align: center;
		padding: 10px 0;
		width: 30%;
		margin: auto !important;
		border-radius: 6px;
		font-size: 1.5rem;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/view/sendSell.vue